/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Translation API
 * OpenAPI spec version: v3
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  TranslationControllerTranslatedAudioResult,
  TranslationControllerTranslationLanguage,
  TranslationRequest
} from './api-v3.schemas.ts';

import { customAxiosInstance } from '../api/mutator.ts';

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key]
    });
  }
  return result;
};

export const translationGetSupportedTranslationLanguages = (language: string, signal?: AbortSignal) => {
  return customAxiosInstance<TranslationControllerTranslationLanguage[]>({
    url: `/api/v3/Translation/languages/${language}`,
    method: 'GET',
    signal
  });
};

export const getTranslationGetSupportedTranslationLanguagesQueryKey = (language: string) => {
  return [`/api/v3/Translation/languages/${language}`] as const;
};

export const getTranslationGetSupportedTranslationLanguagesQueryOptions = <
  TData = Awaited<ReturnType<typeof translationGetSupportedTranslationLanguages>>,
  TError = unknown
>(
  language: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof translationGetSupportedTranslationLanguages>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTranslationGetSupportedTranslationLanguagesQueryKey(language);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof translationGetSupportedTranslationLanguages>>> = ({
    signal
  }) => translationGetSupportedTranslationLanguages(language, signal);

  return {
    queryKey,
    queryFn,
    enabled: language !== null && language !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof translationGetSupportedTranslationLanguages>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type TranslationGetSupportedTranslationLanguagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof translationGetSupportedTranslationLanguages>>
>;
export type TranslationGetSupportedTranslationLanguagesQueryError = unknown;

export function useTranslationGetSupportedTranslationLanguages<
  TData = Awaited<ReturnType<typeof translationGetSupportedTranslationLanguages>>,
  TError = unknown
>(
  language: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof translationGetSupportedTranslationLanguages>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getTranslationGetSupportedTranslationLanguagesQueryOptions(language, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const translationTranslateTo = (translationRequest?: TranslationRequest, signal?: AbortSignal) => {
  return customAxiosInstance<TranslationControllerTranslatedAudioResult>({
    url: `/api/v3/Translation/translateTo`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: translationRequest,
    signal
  });
};

export const getTranslationTranslateToMutationKey = () => ['translationTranslateTo'] as const;

export const getTranslationTranslateToMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof translationTranslateTo>>,
    TError,
    TranslationTranslateToMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof translationTranslateTo>>,
  TError,
  TranslationTranslateToMutationVariables,
  TContext
> => {
  const mutationKey = getTranslationTranslateToMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof translationTranslateTo>>,
    TranslationTranslateToMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return translationTranslateTo(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TranslationTranslateToMutationResult = NonNullable<Awaited<ReturnType<typeof translationTranslateTo>>>;
export type TranslationTranslateToMutationBody = TranslationRequest | undefined;
export type TranslationTranslateToMutationError = unknown;
export type TranslationTranslateToMutationVariables = { data?: TranslationRequest };

export const useTranslationTranslateTo = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof translationTranslateTo>>,
    TError,
    TranslationTranslateToMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof translationTranslateTo>>,
  TError,
  TranslationTranslateToMutationVariables,
  TContext
> => {
  return useMutation(getTranslationTranslateToMutationOptions(options));
};
